import React, { FunctionComponent } from 'react';
import { Article, PageWrapper } from 'components/presentional';
import { getArticleTerms, useRouteTranslations } from 'utils';
import { Redirect, useParams } from 'react-router-dom';
import { usePostsPreview } from 'hooks';
import { WPAcfBlog } from 'types/acf';
import { WPSimpleArticle } from 'types/articles';

interface OwnProps {}

type ArticlePreviewPageProps = Omit<JSX.IntrinsicElements['article'], 'children'> & OwnProps;

const ArticlePreviewPage: FunctionComponent<ArticlePreviewPageProps> = props => {
  const { parentId, revision, preview } = useParams<any>();
  const { translateSlug } = useRouteTranslations();
  const { data: post, loading } = usePostsPreview<WPSimpleArticle<WPAcfBlog>>({ id: parentId, revision, preview });
  const [postData] = post || [];

  if (!parentId || !revision) {
    return <Redirect to={translateSlug('not_found')} />;
  }

  const renderArticle = (article: WPSimpleArticle<WPAcfBlog>) => {
    const { _embedded } = article;
    const terms = getArticleTerms(_embedded);
    const { category: categories = [] } = terms;

    if (categories.find(category => ['webinar', 'ebook', 'case_study'].includes(category.slug))) {
      return null;
    }

    return <Article preview={true} data={article} />;
  };

  return (
    <PageWrapper title={postData?.yoast_title} meta={postData?.yoast_meta} loading={loading} name={'article'}>
      {postData && !loading && renderArticle(postData)}
    </PageWrapper>
  );
};

export default ArticlePreviewPage;
